/**
 * Параметр ?next= после входа. Только свой origin и относительные пути (без open-redirect).
 * Страница OW /auth без сессии ЛК ведёт в тупик — после логина уводим на /ai/.
 */
export function getSafeLoginNext(searchParams) {
  if (!searchParams || typeof searchParams.get !== 'function') return null
  const raw = searchParams.get('next')
  if (!raw || typeof raw !== 'string') return null
  try {
    const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
    const u = raw.startsWith('http') ? new URL(raw) : new URL(raw, base)
    if (typeof window !== 'undefined' && u.origin !== window.location.origin) return null
    const path = u.pathname + u.search
    if (!path.startsWith('/') || path.startsWith('//')) return null
    if (path === '/auth' || path.startsWith('/auth?')) return '/ai/'
    return path
  } catch {
    return null
  }
}
